/**
 * 项目生产环境配置文件
 */

const config = {
    DEBUG: false,
    API_BASE_URL: '//mai.mama.cn/',
    TITLE: '非买不可',
    DESC: '非买不可-妈妈网旗下导购平台，每天精选数百款好货',
    API: {
        PASSPORT_WECHAT_LOGIN_URL: '//passport.mama.cn/wapweixinlogin', // passport 微信登录
        PASSPORT_WAP_LOGIN_URL: '//passport.mama.cn/wapindex/', // passport 登录
        PASSPORT_WAP_LOGOUT_URL: '//passport.mama.cn/index/logout/', // 退出登录
        SET_WEBVIEW_SESSION: '//passport.mama.cn/appapi/setWebViewSession', // 退出登录

        GET_GUESS_LIKE: '/Mapi/Aitaobao/guessNewLike', // 精选好物
        GET_RECOMMEND_LIST_DETAIL: '/Mapi/Recommend_list/index', // 清单列表基础数据
        GET_RECOMMEND_LIST_DATA: '/Mapi/Recommend_list/getData', // 清单列表数据
        GET_SUBJECT_DETAIL: '/Mapi/Subject/getSubjectInfo', // 专题基础数据
        GET_SUBJECT_LIST_DATA: '/Mapi/Subject/getSubjectGoods', // 专题列表基本数据
        IS_LOGIN: '/Mapi/member/is_login', // 判断是否登录
        LOGOUT: '/Mapi/member/logout', // 个人中心页退出登录
        SYN_APP_LOGIN: '/Mapi/member/synAppLogin', // 个人中心页退出登录
        GET_USER_COINS: '/Mapi/member/getUserCoins', // 获取用户金币数
        GET_USER_INFO: '/Mapi/member/index', // 获取用户信息
        GET_FEEDBACK_HISTORY_LIST: '/Mapi/goods_feedback/getHistoryList', // 获取纠错记录列表
        GET_BROWSE_HISTORY_LIST: '/Mapi/browse_history/page', // 获取浏览历史列表
        DEL_BROWSE_HISTORY_LIST: '/Mapi/browse_history/del', // 删除浏览历史列表
        GET_BUSINESS: '/Mapi/business/notice', // 商家合作
        GET_ARTICLE: '/Mapi/article/index', // 联系小编
        GET_FAVORITE_GOODS_LIST: '/Mapi/attention/scrollLoad', // 获取收藏商品/专题/清单列表
        DEAL_ATTENTION: '/Mapi/attention/dealAttention', // 商品关注以及取消以及加金币接口
        GET_SEARCH_META: '/Mapi/featuregoods/index', // 获取找券助手基础信息
        GET_SEARCH_LIST: '/Mapi/featuregoods/ajaxsearch', // 搜索结果信息分页接口
        GET_SECKILL_DATA: '/Mapi/seckill/getSeckillData', // 获取秒杀信息

        GET_INDEX_BASE: '/Mapi/Index/index', // 首页基础数据： tags
        GET_INDEX_BANNER_NAV_ADPOP: '/Mapi/Index/getIndexAd', // 首页 banner广告 / nav 广告位导航 / 广告弹窗
        GET_INDEX_LABELS: '/Mapi/Index/loadBussLabels', // 首页 运营位
        GET_INDEX_INFO_FLOW: '/Mapi/Index/scrollLoad', // 首页、分类页 信息流
        GET_INDEX_SECKILL: '/Mapi/Index/getSeckill', // 首页 秒杀
        GET_INDEX_AD_POP_MAI: '/Mapi/Index/getPopAd', //  首页广告弹窗 - 非买内部数据
        GET_DSP_AD: '//api-luke.mama.cn/gateway/getWapAds', //  首页广告弹窗 - 妈网广告系统

        GET_SHOPPING_LIST_INFO: '/Mapi/ShoppingList/getShoppingListInfo', // 购物清单文章信息 作者信息等
        GET_SHOPPING_LIST_MORE: '/Mapi/ShoppingList/moreNecessaryList', // 更多场景清单
        GET_ABOUT_SHOPPING_LIST: '/Mapi/ShoppingList/getMoreShoppingList', // 获取相关购物清单
        GET_SHOPPING_COLLECT_INDEX: '/Mapi/ShoppingItemCollect/index', // 获取待购列表首页信息
        GET_SCENE_GOODS_LIST: '/Mapi/ShoppingItemCollect/ItemList', // 获取物品列表
        CHANGE_COLLECT_STATUS: '/Mapi/ShoppingItemCollect/ItemCollectChangeStatus', // 待购列表更新物品状态
        ADD_TO_COLLECT: '/Mapi/ShoppingItemCollect/ItemAddToCollect', // 加入待购列表
        GET_TAB_SET: '/Mapi/Index/getTabSet', // 获取购物清单底部导航

        // http://yapi.mama.cn/project/289/interface/api/6049
        SET_SHARE_AWARD_STATE: 'Mapi/Share/shareAward', // 商品分享加金币接口

        GET_GOODS_DETAIL: '/Mapi/index/item',

        GET_TB_GOODS_DETAIL: '//h5api.m.taobao.com/h5/mtop.taobao.detail.getdesc/6.0/',

        POST_GOODS_ATTENTION: '/Mapi/attention/dealAttention',
        POST_FEEDBACK_TYPE: '/Mapi/goods_feedback/createFeedback', // 提交反馈

        GET_TB_CODE: '/Mapi/Aitaobao/getCommand', // 获取淘口令

        // 以下都是非买数据上报
        REPORT_DISKLIKE_GOODS_TYPE_COUNT: '/mapi/index/dislikeGoodTypeCount', // 数据上报：信息流不喜欢商品类型
        REPORT_MAI_GOODS_PV: '/mapi/index/countGoodsPV', // 数据上报：信息流商品曝光
        REPORT_MAI_GOODS_CLICK_PV: '/mapi/index/countGoodsClickPV', // 数据上报：信息流商品点击
        REPORT_CLICK: '/Mapi/Stat/click', // 上报 本地浏览历史
        REPORT_PV: '/Mapi/stat/incPv', // 非买 pv 上报
        REPORT_MAI_SHOPPIHNG_LIST_PV: '/wap/ShoppingList/countListPv' // 购物清单曝光 pv
    },

    IMG_CDN_HOST: '//cdn6.xiaoshuxiong.com/',
    TB_CDN_HOST: '//img.alicdn.com/',
    BI_POSITION: {
        HOME_LIST: 'MAIGOODSINFOUND_LIST_HOME', // 非买不可的首页列表商品信息
        HOME_TAG_LIST: 'MAIGOODSINFOUND_LIST_TABINHOME',
        VIDEO_DETAIL_PAGE: 'MAIGOODSINFOUND_LIST_VIDEODETAIL', // 非买不可的视频详情
        HOME_PAGE: 'MAIGOODSINFOUND_TAB_INHOME', // 首页或个人化分类 tag 页的曝光
        MAI_PAGE: 'MAIGOODSINFOUND_PAGE', // 非买所有页面曝光
        GOODS_INFO_FLOW_DIKE: 'MAIGOODSINFOUND_LIST_UNLIKE_DETAIL', // 信息流不喜欢的商品用户反馈
        SHOPPING_LIST_DETAIL: 'SHOPPING_LIST_DETAIL' // 购物清单详情上报
    },

    // 商品分类 (待后端有空给接口，这部分数据改用接口获取)
    // eslint-disable-next-line @typescript-eslint/naming-convention
    GOODS_ClASSIFY: [
        {tid: 61, ttext: '备孕刚需', status: 1},
        {tid: 59, ttext: '猜你喜欢', status: 1},
        {tid: 57, ttext: '家居家装', status: 1},
        {tid: 56, ttext: '内衣', status: 1},
        {tid: 55, ttext: '运动户外', status: 1},
        {tid: 54, ttext: '男装', status: 1},
        {tid: 53, ttext: '女装', status: 1},
        {tid: 52, ttext: '综合', status: 1},
        {tid: 51, ttext: '药品/保健品/医疗用具', status: 1},
        {tid: 50, ttext: '孕产妇用品（孕妇装/溢乳垫等）', status: 1},
        {tid: 48, ttext: '手机配件/数码3C/充值卡券', status: 1},
        {tid: 46, ttext: '儿童用品', status: 1},
        {tid: 45, ttext: '书籍/文具/办公用品', status: 1},
        {tid: 43, ttext: '精品', status: 0},
        {tid: 41, ttext: '促销活动', status: 0},
        {tid: 40, ttext: '其他', status: 1},
        {tid: 38, ttext: '母婴用品', status: 1},
        {tid: 36, ttext: '摄影摄像', status: 0},
        {tid: 34, ttext: '家居日用', status: 1},
        {tid: 32, ttext: '数码家电', status: 1},
        {tid: 30, ttext: '妈妈圈独家推荐', status: 0},
        {tid: 28, ttext: '食品酒水', status: 1},
        {tid: 26, ttext: '纸尿片', status: 0},
        {tid: 24, ttext: '鞋包配饰', status: 1},
        {tid: 22, ttext: '儿童玩具', status: 0},
        {tid: 20, ttext: '婴儿用品（奶粉/纸尿裤/奶瓶/口水巾等）', status: 0},
        {tid: 18, ttext: '厨房用品（餐具/小家电/收纳等）', status: 0},
        {tid: 14, ttext: '美妆个护', status: 1}
    ]
};

export default config;
